import { WithStyles, withStyles } from '@mui/styles';
import { ClientMessageRecord } from '@tassat/fred-definitions';

import { DeclineClientMessage } from './declineClientMessage';
import { muiStyles } from './styles';

export interface DeclineClientMessageProps extends WithStyles<typeof muiStyles> {
    selectedMessage: ClientMessageRecord;
    declineMessage: () => void;
    cancelConfirm: () => void;
    approvalError: string;
}

export default withStyles(muiStyles)(DeclineClientMessage);